import { LOCALES } from "./locales.config";

export const STORAGE_KEY = "iap_lang";

export const DEFAULT_LOCALE =
  (LOCALES.find((l) => l.default) || LOCALES[0]).code;

export const getEnabledLocales = () => LOCALES.filter((l) => l.enabled);

export const getLocale = (code) => LOCALES.find((l) => l.code === code);

export const isEnabled = (code) =>
  !!LOCALES.find((l) => l.code === code && l.enabled);

// A code that should appear as a URL prefix (enabled AND not the default).
export const isPrefix = (code) => isEnabled(code) && code !== DEFAULT_LOCALE;

// Parse a pathname into { locale, page }. The site is a single page, so `page`
// is always 'home'; we only need to extract the (optional) locale prefix.
export function parsePath(pathname) {
  const segs = pathname.split("/").filter(Boolean);
  let locale = DEFAULT_LOCALE;
  if (segs[0] && isPrefix(segs[0])) {
    locale = segs[0];
  }
  return { locale, page: "home" };
}

// Build the localized path for the (single) home page in a given locale.
export function localizePath(page, code) {
  const prefix = code === DEFAULT_LOCALE ? "" : `/${code}`;
  return prefix || "/";
}

// First enabled locale that matches the browser's language list, or undefined.
export function browserMatch() {
  if (typeof navigator === "undefined") return undefined;
  const langs = navigator.languages || [navigator.language || ""];
  for (const l of langs) {
    const code = String(l).slice(0, 2).toLowerCase();
    if (isEnabled(code)) return code;
  }
  return undefined;
}

// og:locale value derived purely from config (code + flag region).
export function ogLocale(code) {
  const cfg = getLocale(code) || getLocale(DEFAULT_LOCALE);
  return `${cfg.code}_${cfg.flag}`;
}
